import { createClient } from '@supabase/supabase-js';
import { sessionStorageGate } from './tabSession';

export const SUPABASE_URL = 'https://uscjyqgfncqoqqegrcjw.supabase.co';
// Active publishable key (replaces the old disabled anon key)
export const SUPABASE_ANON_KEY = 'sb_publishable_U-TvZCpI7GZk_XT0WK6C2Q_4BlIuEo9';

/*
  **The session is kept where Supabase keeps it, 7 September 2026.**

  It was in `sessionStorage`, which is a per-tab box that is emptied the moment
  the tab closes. That was almost certainly meant as a security measure, and it
  is not the one doing the work: OnHand already signs a person out after sixty
  minutes of doing nothing, which is what protects a machine somebody walks away
  from. Closing a tab is not.

  **What it cost is worse than what it bought.** Supabase's own machinery, its
  token refresh and its lock that stops two tabs fighting over one session,
  assumes the ordinary place. A per-tab box means every tab is a separate
  sign-in, a reopened tab is signed out, and any browser setting that restricts
  site data takes the session away between one request and the next, which looks
  exactly like signing in and being thrown straight back out.

  So it uses the default. `persistSession` is the default too and is left in
  because it is the point.

  **But closing every OnHand tab now ends it**, 18 September 2026, on the
  owner's word: he closed Safari, opened it again and walked straight in. The
  store is still `localStorage` under the same keys, handed over through
  `sessionStorageGate` (src/lib/tabSession.js), which holds every read until
  this tab has asked whether any other OnHand tab is open, and deletes the
  saved session first if none is. Nothing about the fault above comes back:
  a tab keeps its session for as long as any OnHand tab is open.
*/
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: sessionStorageGate,
  },
});

/*
  **Which build this is.** Netlify passes the commit it built; anything else says
  so. It is printed in the corner of the sign-in screen, because on 7 September
  an hour went into a fault that could not be diagnosed without knowing whether
  the browser was running the fix or the version before it, and there was no way
  to tell from the outside.
*/
export const BUILD = (process.env.REACT_APP_BUILD || 'local').slice(0, 7);

export const ADMIN_EMAIL = 'medexinventory@medexpsi.com';

